import { z } from 'zod/v4';

export const SENDING_MEDIA = ['email', 'post', 'registered_post'] as const;

export type SendingMedia = (typeof SENDING_MEDIA)[number];

export const SendingMediaSchema = z.enum([...SENDING_MEDIA]);
